import { useUserStore } from "@/stores/user";

import { fetchJSON } from "./utils";

function formatSearchResult(result) {

  const transformDate = (theDate) => {
    let transformedDate = theDate.replace("+00:00", "000")
    return new Date(transformedDate).toLocaleDateString(
      "en-US",
      {
        month: "short",
        day: "2-digit",
        year: "numeric"
      }
    );
  };

  if (result.created_at) {
    result.created_at_mmm_dd_yyyy = transformDate(result.created_at);
  }

  if (result.query_created_at) {
    result.query_created_at_mmm_dd_yyyy = transformDate(result.query_created_at);
  }

  return result;
}

export async function fetchAll(searchInput) {
  const userStore = useUserStore();
  const params = {
    search_input: searchInput,
    organization_id: userStore.authUserOrganizationId,
  }
  const url = `/api/search/all`;
  const res = await fetchJSON(url, params, null, "get");
  // here res is {data:{query:{docs, nb_results, field?}}}
  for (let key of Object.keys(res.data)) {
    res.data[key].docs = res.data[key].docs.map(formatSearchResult)
  }

  return res.data;
}
